<template>
  <div class="app-container container-fluid p-0">
    <LeftNav :router="$router" :route="$route" :permissions="permissions" app="pinnacle" />
        <div class="main-content">
      <router-view class="router-view" :key="activeViewKey" />
    </div>
 
    <MaintenanceModal />
 
  </div>
</template>

<script>
import { LeftNav } from 'pinnacle-lib';
import MaintenanceModal from "@/components/partials/MaintenanceModal";
import 'moment-timezone';
import {explorePerms, homePerms} from '../router/index.js';

export default {
  components: {
    LeftNav,
    MaintenanceModal,
  },
  computed: {
    permissions() {
      return this.$persistingStore.state.user.permissions;
    },
    activeViewKey() {
      // Key on path only (not fullPath) so query-string changes — e.g. opening the
      // Places view modal via ?near_poi_id=... — don't remount the whole view and
      // wipe in-memory state like applied filters. Path/param changes still remount.
      return this.$route.path;
    }
  },
  beforeMount() {
    if (this.$route.name === 'app-layout') {
      const last = localStorage.getItem('last');
      if (last !== null) {
        const lastRoute = this.$router.resolve(last).route;
        if (lastRoute.meta && lastRoute.meta.routeGuard && !this.hasPermissions(lastRoute.meta.routeGuard, this.permissions, false)) {
          console.log('Insufficent permissions for lastRoute '+ last);
          localStorage.removeItem('last');
        } else {
          localStorage.removeItem('last');
          this.$router.push(last);
          return;
        }
      }

      if (this.hasPermissions(homePerms, this.permissions, false)) {
        this.$router.push('/home');
        return;
      }
      
      if (this.hasPermissions(explorePerms, this.permissions, false)) {
        this.$router.push('/explore');
        return;
      }

      this.$router.push('/settings');
    }
  },
  data() {
    return {
      isLoggedIn: false,
      changeWidth: false,
      maintenanceMode: false,
      redshiftMaintenanceWindow: false,
      redshiftMaintenanceEnd: null,
      checkIntervalId: null
    };
  },
  created() {
    this.isLoggedIn = this.$route.name != "login";
  },
  watch: {
    "$route.name": function(routeName) {
      this.isLoggedIn = routeName != "login";
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  height: 100%;
  width: calc(100% - 80px);
  margin-left: 80px;
  overflow: hidden;
}

.app-container {
  height: 100%;
  width: 100%;
}

.router-view {
  height: 100%;
  width: 100%;
}

</style>
